/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileSchemaIn
 */
export interface FileSchemaIn {
    /**
     * 
     * @type {string}
     * @memberof FileSchemaIn
     */
    s3key?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaIn
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaIn
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaIn
     */
    extension?: string;
    /**
     * 
     * @type {number}
     * @memberof FileSchemaIn
     */
    fileSize?: number;
    /**
     * 
     * @type {number}
     * @memberof FileSchemaIn
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof FileSchemaIn
     */
    width?: number;
    /**
     * 
     * @type {string}
     * @memberof FileSchemaIn
     */
    url?: string;
}

/**
 * Check if a given object implements the FileSchemaIn interface.
 */
export function instanceOfFileSchemaIn(value: object): boolean {
    return true;
}

export function FileSchemaInFromJSON(json: any): FileSchemaIn {
    return FileSchemaInFromJSONTyped(json, false);
}

export function FileSchemaInFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileSchemaIn {
    if (json == null) {
        return json;
    }
    return {
        
        's3key': json['s3key'] == null ? undefined : json['s3key'],
        'fileName': json['file_name'] == null ? undefined : json['file_name'],
        'contentType': json['content_type'] == null ? undefined : json['content_type'],
        'extension': json['extension'] == null ? undefined : json['extension'],
        'fileSize': json['file_size'] == null ? undefined : json['file_size'],
        'height': json['height'] == null ? undefined : json['height'],
        'width': json['width'] == null ? undefined : json['width'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function FileSchemaInToJSON(value?: FileSchemaIn | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        's3key': value['s3key'],
        'file_name': value['fileName'],
        'content_type': value['contentType'],
        'extension': value['extension'],
        'file_size': value['fileSize'],
        'height': value['height'],
        'width': value['width'],
        'url': value['url'],
    };
}

